import {
  EventName,
  ITrackCommunitiesAccessEvent,
  ITrackEvent,
} from '@/models/TrackEvent'
import { AnalyticsService } from '@/service'
import AnalyticsServiceCls from '@/service/AnalyticsService'

import { Capacitor } from '@capacitor/core'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'
import { UserState } from './users'

class IAnalyticsState {
  async trackEvent(trackEvent: ITrackEvent) {
    const analyticsService = new AnalyticsServiceCls()
    await analyticsService.trackEvent(trackEvent)
  }
  async trackCourseAccessEvent(eventData: Record<string, any>) {
    await this.trackEvent({
      eventName: EventName.COURSE_ACCESS_REFRESH,
      eventData,
      contactId: UserState.state.currentUser?.contactId,
    })
  }
  async trackNoCommunitiesEvent() {
    const catValue = Cookies.get('cat') || window.localStorage.getItem('cat')
    let firebaseToken
    try {
      firebaseToken = catValue ? JSON.parse(window.atob(catValue)) : null
    } catch (err) {
      console.error(err)
    }

    if (catValue) {
      let decodedToken: any = null
      try {
        decodedToken = jwtDecode(firebaseToken?.token)
      } catch (err) {
        console.error(err)
      }

      // Uncomment this if you want to track the event with the decoded token
      await this.trackEvent({
        eventName: EventName.NO_COMMUNITIES_FOUND,
        eventData: {
          locationId: decodedToken?.claims?.locationId,
          contactId: decodedToken?.claims?.contact_id,
          event: localStorage.getItem('event') ?? 'not-found',
          cat: catValue,
          platform: Capacitor?.getPlatform(),
          userAgent: navigator?.userAgent,
        },
        contactId: UserState.state.currentUser?.contactId,
      })
    }
  }

  async trackCommunitiesAccessEvent(payload: ITrackCommunitiesAccessEvent) {
    try {
      const contactId = UserState.state.currentUser?.contactId
      if (!contactId) {
        return
      }
      await AnalyticsService.trackCommunitiesAccessEvent({
        ...payload,
        contactId,
        eventName: EventName.COMMUNITIES_GROUP_ACCESS,
      })
    } catch (error) {
      console.error(error)
    }
  }
}

export const AnalyticsState = new IAnalyticsState()
